import { GlobalReducer } from '../../app';
import { Reducer } from 'redux';
import { initialResponseState, IResponseState } from '../../state';
import { IAdminGetHospitalsAction, AdminTypes, AdminGetHospitalsActions } from './admin.type';

export const HospitalsSettingReducer: Reducer<IResponseState, IAdminGetHospitalsAction> = (
	state = initialResponseState,
	action: AdminGetHospitalsActions,
) => GlobalReducer(state, action, AdminTypes.ADMIN_GET_HOSPITALS.toString());
